import { fetchJson } from '@api/ApiHelper';

// Flag to enable mock responses for testing
const USE_MOCK_RESPONSES = false; // Set to false to use real API calls

export interface FaceBoundingBoxResponse {
  width: number;
  height: number;
  left: number;
  top: number;
}

export interface AttachmentFaceResponse {
  id: string;
  boundary_id: string;
  source_id: string;
  source_url: string;
  face_count?: number;
  created_at: string;
  updated_at: string;
  identity_id: string;
  aws_face_id: string;
  confidence: number;
  bounding_box: FaceBoundingBoxResponse;
  identity_name?: string;
  face_thumbnail_url: string;
  identity_thumbnail_url: string;
  identity_metadata?: string;
}

export interface BrandfolderFaceResponse {
  id: string;
  source_url: string;
  identity_name: string;
  bounding_box: FaceBoundingBoxResponse;
}

export interface GetBrandfolderFacesOptions {
  brandfolderKey: string;
}

// Mock data for testing
const mockFacesResponse: AttachmentFaceResponse[] = [
  {
    id: '019a5e10-5c54-71c1-9198-6b5fa6dcd19d',
    boundary_id: '875849qn8knttxsv9qj2gqf',
    source_id: 'b9jjvfg49vmg736fj7jwsm4',
    source_url:
      // eslint-disable-next-line max-len
      'https://storage-us-dev-gcs.bfldr.com/b9jjvfg49vmg736fj7jwsm4/v/158/element.jpeg?Expires=1762601117&KeyName=gcs-bfldr-dev&Signature=8adJ1ZaLhs7tVFDOh38rTleKM8Y=',
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    identity_id: '019a5e10-5c54-71c2-92a8-18ea4cc38da7',
    aws_face_id: 'f6f1df32-8cb0-4f75-a06e-973136a4f0f1',
    confidence: 99.98583984375,
    bounding_box: {
      width: 0.1123587638139725,
      height: 0.2964327931404114,
      left: 0.1888398677110672,
      top: 0.1381245702505112
    },
    face_thumbnail_url: 'https://example.com/placeholder1.jpg',
    identity_thumbnail_url: 'https://example.com/placeholder1.jpg'
  },
  {
    id: '019a5e10-589b-71c0-802f-666484cd02ea',
    boundary_id: '875849qn8knttxsv9qj2gqf',
    source_id: 'b9jjvfg49vmg736fj7jwsm4',
    source_url:
      // eslint-disable-next-line max-len
      'https://storage-us-dev-gcs.bfldr.com/b9jjvfg49vmg736fj7jwsm4/v/158/element.jpeg?Expires=1762601117&KeyName=gcs-bfldr-dev&Signature=8adJ1ZaLhs7tVFDOh38rTleKM8Y=',
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    identity_id: '019a5e10-589b-71c1-8c98-d3651490bc41',
    aws_face_id: 'c25ebec3-ef86-4eb0-8877-3562180664af',
    confidence: 99.97870635986328,
    bounding_box: {
      width: 0.1283322423696518,
      height: 0.3371252119541168,
      left: 0.7087556719779968,
      top: 0.1480732262134552
    },
    face_thumbnail_url: 'https://i.pravatar.cc/150?img=1',
    identity_thumbnail_url: 'https://i.pravatar.cc/150?img=1'
  },
  {
    id: '019a5e10-589b-71c0-802f-666484cd02eb',
    boundary_id: '875849qn8knttxsv9qj2gqf',
    source_id: 'b9jjvfg49vmg736fj7jwsm4',
    source_url:
      // eslint-disable-next-line max-len
      'https://storage-us-dev-gcs.bfldr.com/b9jjvfg49vmg736fj7jwsm4/v/158/element.jpeg?Expires=1762601117&KeyName=gcs-bfldr-dev&Signature=8adJ1ZaLhs7tVFDOh38rTleKM8Y=',
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    identity_id: '019a5e10-589b-71c1-8c98-d3651490bcda',
    aws_face_id: 'c25ebec3-ef86-4eb0-8877-3562180664af',
    confidence: 99.97870635986328,
    bounding_box: {
      width: 0.1283322423696518,
      height: 0.3371252119541168,
      left: 0.7087556719779968,
      top: 0.1480732262134552
    },
    identity_name: 'Test Identity',
    face_thumbnail_url: 'https://i.pravatar.cc/150?img=2',
    identity_thumbnail_url: 'https://i.pravatar.cc/150?img=2'
  }
];

const mockIdentitiesResponse: IdentityResponse[] = [
  {
    id: 'identity-1',
    name: 'Tayler Reed',
    face_thumbnail_url: 'https://i.pravatar.cc/150?img=3',
    identity_thumbnail_url: 'https://i.pravatar.cc/150?img=3',
    tag_count: 5
  },
  {
    id: 'identity-2',
    name: 'Alex Johnson',
    face_thumbnail_url: 'https://i.pravatar.cc/150?img=4',
    identity_thumbnail_url: 'https://i.pravatar.cc/150?img=4',
    tag_count: 3
  },
  {
    id: 'identity-3',
    name: 'Jamie Smith',
    face_thumbnail_url: 'https://i.pravatar.cc/150?img=5',
    identity_thumbnail_url: 'https://i.pravatar.cc/150?img=5',
    tag_count: 8
  },
  {
    id: 'identity-4',
    name: 'Casey Brown',
    face_thumbnail_url: 'https://i.pravatar.cc/150?img=6',
    identity_thumbnail_url: 'https://i.pravatar.cc/150?img=6',
    tag_count: 2
  },
  {
    id: 'identity-5',
    name: 'Ross Geller',
    face_thumbnail_url: 'https://i.pravatar.cc/150?img=7',
    identity_thumbnail_url: 'https://i.pravatar.cc/150?img=7',
    tag_count: 12
  }
];

export interface GetAttachmentFacesOptions {
  attachmentKey: string;
  brandfolderKey: string;
}

export enum PeopleTaggingStatus {
  WaitingForPeopleTagging = 'waiting_for_people_tagging',
  CompletedPeopleTagging = 'completed_people_tagging',
  FailedPeopleTagging = 'failed_people_tagging'
}

export interface GetAttachmentStatusResponse {
  data: {
    id: string;
    type: string;
    attributes: {
      status: PeopleTaggingStatus | string;
    };
  };
}

export interface UpdateFaceNameOptions {
  personId: string;
  brandfolderKey: string;
  name: string;
}

export interface DeleteFaceNameOptions {
  faceId: string; // Required for API compatibility, but faceIds array takes precedence
  attachmentKey: string;
  brandfolderKey: string;
  faceIds?: string[]; // Optional array of face IDs to batch delete
}

export interface IdentityResponse {
  id: string;
  name: string;
  tag_count?: number;
  face_count?: number;
  face_thumbnail_url: string;
  identity_thumbnail_url: string;
}

interface MergeIdentitiesParams {
  sourceIdentityId: string;
  destinationIdentityId: string;
  destinationName?: string;
  sourceName?: string;
}

interface MergeIdentitiesResponse {
  id: string;
  identity_name: string;
  source_url: string;
}

export interface GetIdentitiesOptions {
  brandfolderKey: string;
}

// Common face response for bulk operations
export interface CommonFaceResponse {
  face_ids: string[];
  identity_name: string;
  identity_thumbnail_url: string;
}

export interface GetCommonFacesOptions {
  brandfolderKey: string;
  assetKeys: string[];
}

export interface SplitFacesOptions {
  brandfolderKey: string;
  faceIds: string[];
}

// Request 1: Get attachment status
export const getAttachmentStatus = async (
  attachmentKey: string
): Promise<GetAttachmentStatusResponse> => {
  if (USE_MOCK_RESPONSES) {
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 300));
    return Promise.resolve({
      data: {
        id: attachmentKey,
        type: 'attachments',
        attributes: {
          status: PeopleTaggingStatus.CompletedPeopleTagging
        }
      }
    });
  }

  return fetchJson<GetAttachmentStatusResponse>({
    url: `/api/v4/attachments/${attachmentKey}`,
    params: {
      fields: 'status'
    }
  });
};

// Request 2: Get faces for an attachment
export const getAttachmentFaces = async (
  options: GetAttachmentFacesOptions
): Promise<AttachmentFaceResponse[]> => {
  const { attachmentKey, brandfolderKey } = options;

  if (USE_MOCK_RESPONSES) {
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 500));
    return Promise.resolve(mockFacesResponse);
  }

  return fetchJson<AttachmentFaceResponse[]>({
    url: `/api/v4/private/people_tagging/brandfolders/${brandfolderKey}/attachments/${attachmentKey}/faces`
  });
};

// Request 3: Update face name
export const updateIdentityName = async (
  options: UpdateFaceNameOptions
): Promise<void> => {
  const { personId, brandfolderKey, name } = options;

  if (USE_MOCK_RESPONSES) {
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 300));
    console.log(`[MOCK] Updating face ${personId} with name: ${name}`);
    return Promise.resolve();
  }

  return fetchJson<void>({
    url: `/api/v4/private/people_tagging/brandfolders/${brandfolderKey}/identities/${personId}`,
    method: 'PUT',
    body: { name }
  });
};

// Request 4: Delete face(s)
export const deleteFaceName = async (
  options: DeleteFaceNameOptions
): Promise<void> => {
  const { faceId, attachmentKey, brandfolderKey, faceIds } = options;

  // Use faceIds array if provided, otherwise use single faceId
  const facesToDelete = faceIds && faceIds.length > 0 ? faceIds : [faceId];

  if (USE_MOCK_RESPONSES) {
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 300));
    console.log(`[MOCK] Deleting faces ${facesToDelete.join(', ')} from attachment ${attachmentKey}`);
    return Promise.resolve();
  }

  // Pass face_ids array in request body to specify which faces to delete
  return fetchJson<void>({
    url: `/api/v4/private/people_tagging/brandfolders/${brandfolderKey}/attachments/${attachmentKey}/faces`,
    method: 'DELETE',
    body: { face_ids: facesToDelete }
  });
};

// Request 5: Get identities for dropdown
export const getIdentities = async (
  options: GetIdentitiesOptions
): Promise<IdentityResponse[]> => {
  const { brandfolderKey } = options;

  if (USE_MOCK_RESPONSES) {
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 400));
    return Promise.resolve(mockIdentitiesResponse);
  }

  return fetchJson<IdentityResponse[]>({
    url: `/api/v4/private/people_tagging/brandfolders/${brandfolderKey}/identities`
  });
};

export const getBrandfolderFaces = async (
  options: GetBrandfolderFacesOptions
): Promise<BrandfolderFaceResponse[]> => {
  const { brandfolderKey } = options;

  return fetchJson<BrandfolderFaceResponse[]>({
    url: `/api/v4/private/people_tagging/brandfolders/${brandfolderKey}/faces`,
    method: 'GET',
  });
};

export const mergeIdentities = async (
  options: MergeIdentitiesParams
): Promise<MergeIdentitiesResponse> => {
  const brandfolderKey = BFG.brandfolder_key;
  const { sourceIdentityId, destinationIdentityId, destinationName, sourceName } = options;

  if (USE_MOCK_RESPONSES) {
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 300));
    console.log(`[MOCK] Merging identities ${sourceName || 'Unknown'} and ${destinationName}`);
    return Promise.resolve({
      id: '123',
      identity_name: 'Merged Identity',
      source_url: 'https://example.com/placeholder.jpg'
    });
  }

  return fetchJson<MergeIdentitiesResponse>({
    url: `/api/v4/private/people_tagging/brandfolders/${brandfolderKey}/identities/merge`,
    method: 'POST',
    body: {
      destination_identity_id: destinationIdentityId,
      source_identity_id: sourceIdentityId,
      destination_name: destinationName || '',
      source_name: sourceName || '',
    },
  });
};

// Request: Get common faces for selected assets (bulk operation)
export const getCommonFaces = async (
  options: GetCommonFacesOptions
): Promise<CommonFaceResponse[]> => {
  const { brandfolderKey, assetKeys } = options;

  return fetchJson<CommonFaceResponse[]>({
    url: `/api/v4/private/people_tagging/brandfolders/${brandfolderKey}/faces/common`,
    method: 'POST',
    body: {
      asset_keys: assetKeys,
    },
  });
};

// Request: Split/remove people tags from faces (bulk operation)
export const splitFaces = async (
  options: SplitFacesOptions
): Promise<void> => {
  const { brandfolderKey, faceIds } = options;

  return fetchJson<void>({
    url: `/api/v4/private/people_tagging/brandfolders/${brandfolderKey}/faces/split`,
    method: 'POST',
    body: {
      face_ids: faceIds,
    },
  });
};
